<template>
  <svg 
    :class="{ currentColor: currentColor, icon_hover: isHover, icon_active: checked && !isCustom}"
    class="svg-icon"
    :style="{ 'width' : width ? width+'px' : '1em','height' : height ? height + 'px' : ( width ? width + 'px' : '1em')}">
    <use v-if="isCustom && checked" :xlink:href="`${iconName}_active`"></use>
    <use v-else :xlink:href="iconName"></use>
  </svg>
</template>

<script>
  /**
     * ComponentName: icon展示
     * Created Date:2022/4/12
     * Author: zhangch
     * Modify: shishuo·zhang 2022/4/28 | Nancy 2022/5/12
     * Modify: 张钧 2022/8/22 更改type=custom自定义选中样式
     * 组件说明：
     * @param {String | Number}   width  传入宽度，不传则继承父级的font-size;
     * @param {String | Number}   height  传入高度，不传则默认和宽度一样;
     * @param {String}  iconClass  icons文件夹中icon名
     * @param {Boolean}  currentColor  // 是否需要继承父级颜色，单一线条默认为true，元素丰富的彩色图为false
     * eg:
     *     <cl-svg-icon></cl-svg-icon>
     */
export default {
  name: 'cl-svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    currentColor: {
      type: Boolean,
      default: true
    },
    width: {
      type: [String, Number],
      default:''
    },
    height: {
      type: [String, Number],
      default:''
    },
    // default: 没有其他效果，hover：鼠标滑过效果 custom：自定义
    type: {
        type: String,
        default: 'default'
    },
    // 选中状态适配VI
    checked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    isHover() {
        return this.type === 'hover'
    },
    // 自定义文件样式
    isCustom() {
        return this.type === 'custom';
    }
  }
}
</script>

<style lang='scss' scoped>
.svg-icon {
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  cursor: pointer;
}
.svg-icon.currentColor {
  stroke: currentColor;
}
.icon_active, .icon_hover:hover {
    stroke: $base-color-theme !important;
    fill: $base-color-theme !important;
}
</style>
